import { AxiosRequestConfig } from 'axios'

export interface AverageFrequencyParams {
  startDate: string
  endDate: string
  storeIds?: string
}

export interface FrequencyStats {
  general: {
    value: number
    prev: number
    diff: number
    isPositive: boolean
  }
  recurrent: {
    value: number
    prev: number
    diff: number
    isPositive: boolean
  }
  byLevel: Array<{
    nivel: string
    value: number
    prev: number
    diff: number
    isPositive: boolean
  }>
}

export interface AverageFrequencyResponse {
  data: FrequencyStats
}

const getAverageFrequency = (params: AverageFrequencyParams): AxiosRequestConfig => ({
  url: '/dashboard/average-frequency',
  method: 'GET',
  params,
})

export { getAverageFrequency }
